import React, { useState } from "react";

import { useLoaderData } from "react-router-dom";
import Select from "react-select";
import _ from "lodash";

import { Save2Fill } from "react-bootstrap-icons";
import { Icon } from "../util/Icon";

function ProductPriceCodes() {
  const serverResponse = useLoaderData();

  const banners = serverResponse.banners;
  const entity = serverResponse.entity;

  const [prices, setPrices] = useState(entity.prices);
  const [filteredCode, setFilteredCodes] = useState(prices);
  const [searchText, setSearchText] = useState("");

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchText(searchTerm);

    setFilteredCodes(filterPrices(prices, searchTerm));
  };

  function filterPrices(prices, searchTerm) {
    const searchFields = ["banner", "province", "code"];

    return prices.filter((price) => {
      for (let index = 0; index < searchFields.length; index++) {
        const f = searchFields[index];

        let val;

        if (_.isObject(price[f])) val = price[f].name;
        else val = price[f];

        if (val.toLowerCase().includes(searchTerm.toLowerCase())) {
          return true;
        }
      }

      return false;
    });
  }

  const handleDelete = (province, banner) => {
    const _prices = prices.filter((p) => {
      if (banner.id === p.banner.id && province.id === p.province.id) {
        return false;
      }
      return true;
    });
    setPrices(_prices);
    setFilteredCodes(filterPrices(_prices, searchText));
  };

  const handleNewPriceCode = (priceCode) => {
    const _prices = [...prices, priceCode];

    setPrices(_prices);
    setFilteredCodes(filterPrices(_prices, searchText));
  };

  return (
    <div className="col m-4">
      <input type="hidden" name="prices" value={JSON.stringify(prices)} />
      <NewPriceCode banners={banners} onNewPrice={handleNewPriceCode} />

      <div className="row my-3">
        <div className="col">
          <input
            className="form-control me-2"
            type="search"
            value={searchText}
            onChange={handleSearch}
            placeholder="Search"
            aria-label="Search"
          />
        </div>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th scope="col">Code</th>
            <th scope="col">Price</th>
            <th scope="col">Banner</th>
            <th scope="col">Province</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {filteredCode.map((priceCode, i) => {
            return (
              <PriceCode
                key={i}
                price={priceCode.retailPrice}
                code={priceCode.code}
                banner={priceCode.banner}
                province={priceCode.province}
                handleDelete={handleDelete}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function PriceCode({ code, price, banner, province, handleDelete }) {
  return (
    <tr>
      <td>{code}</td>
      <td>{price}</td>
      <td>{banner.name}</td>
      <td>{province.name}</td>
      <td>
        <Icon
          iconName="Trash"
          className="fas me-2"
          aria-hidden="true"
          onClick={() => handleDelete(province, banner)}
        />
      </td>
    </tr>
  );
}

function NewPriceCode({ banners, onNewPrice }) {
  const [provinces, setProvinces] = useState([]);
  const [code, setCode] = useState("");
  const [price, setPrice] = useState("");
  const [province, setProvince] = useState();
  const [banner, setBanner] = useState();

  const handleBannerSelection = (banner) => {
    setProvinces(banner.provinces);
    setBanner(banner);
  };

  const handleProvinceSelection = (province) => {
    setProvince(province);
  };

  const handleCodeChange = (e) => {
    const code = e.target.value;
    setCode(code);
  };

  const handlePriceChange = (e) => {
    const price = e.target.value;
    setPrice(price);
  };

  const handleSaveButtonClicked = () => {
    const newPriceCode = {
      code,
      retailPrice: price,
      banner,
      province,
    };

    console.log(JSON.stringify(newPriceCode));
    onNewPrice(newPriceCode);
  };

  return (
    <div className="row">
      <div className="col-2">
        <Select
          getOptionLabel={(banner) => banner.name}
          getOptionValue={(banner) => {
            if (banner.id) return banner.id;
            return banner.name;
          }}
          onChange={handleBannerSelection}
          options={banners}
        />
      </div>
      <div className="col-5">
        <Select
          getOptionLabel={(province) => province.name}
          getOptionValue={(province) => {
            if (province.id) return province.id;
            return province.name;
          }}
          onChange={handleProvinceSelection}
          options={provinces}
        />
      </div>
      <div className="col-2">
        <input
          type="text"
          placeholder="Code"
          className="form-control pe-3"
          value={code}
          onChange={handleCodeChange}
        />
      </div>
      <div className="col-2">
        <input
          placeholder="Price"
          type="text"
          className="form-control pe-3"
          value={price}
          onChange={handlePriceChange}
        />
      </div>
      <div className="col-1">
        <button
          onClick={handleSaveButtonClicked}
          type="button"
          className="btn btn-outline-secondary"
          aria-label="save"
        >
          {/* <Icon iconName="Save" className="fas" aria-hidden="true"></Icon> */}
          <Save2Fill />
        </button>
      </div>
    </div>
  );
}

export default ProductPriceCodes;
